import React, { FC } from "react";

const style: React.CSSProperties = {
    height: "auto",
    verticalAlign: "middle",
    width: 20
};

const LexIcon: FC<{ style?: React.CSSProperties }> = (props) => {
    return <img style={{ ...style, ...props.style }} src="/img/lex-logo.svg" alt="AWS Lex" />;
};

export { LexIcon };